export default __webpack_public_path__ + "static/media/1.12758b84.png";